const config = {
  url: "https://lmt.timeonegroup.com/api/validation",
  defaultErrorMessage: "Merci de saisir une valeur valide",
  delay: 500,
};
export default config;
